// Custom scripts
import DetectMobileBrowsers from "../../utils/detect-mobile-browsers";
import Termin from "./termin";
import Bilety from "./bilety";
import TerminMobile from "./termin-mobile";

(() => {
  if (typeof $ === "undefined") {
    throw new TypeError("... requires jQuery.");
  }

  $(document).ready(() => {
    const isMobileBrowser = DetectMobileBrowsers.check();

    if (isMobileBrowser) {
      const terminMobile = new TerminMobile();
      const bilety = new Bilety();

      terminMobile.init();
      bilety.init();
    } else {
      const termin = new Termin();
      const bilety = new Bilety();

      termin.init();
      bilety.init();
    }
  });
})();
